import {useTranslation} from "react-i18next";
import {useCallback, useEffect, useRef, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {Box, Button, IconButton } from "@mui/material";
import {Close, Sync} from "@mui/icons-material";
import DialogContent from "@mui/material/DialogContent";
import Field from "../../../common/components/forms/Field";
import fieldCalendar from "../../../common/components/forms/fields/FieldCalendar";
import {AgGridReact} from "ag-grid-react";
import {getAgGridDefault} from "../../../common/components/agGrid/agGridUtility";
import AgGridContainer from "../../../common/layout/AgGridContainer";
import Form from "../../../common/components/forms/Form";
import useForm from "../../../common/components/hooks/useForm";

const opcionesSync = [
    { id: 1, key: 'bancos', nombre: 'Bancos', checked: false },
    { id: 2, key: 'terminos-pago', nombre: 'Términos de Pago', checked: false },
    { id: 3, key: 'proveedores', nombre: 'Proveedores' },
    { id: 4, key: 'productos', nombre: 'Productos' },
    { id: 5, key: 'ordenes-compra', nombre: 'Órdenes de Compra' },
    { id: 6, key: 'recepciones', nombre: 'Recepciones' },
];


const SincronizacionOCs = ({ open, onClose, onSyncClicked }) => {
    const {t} = useTranslation();
    const gridRef = useRef(null);
    const [datos] = useState(opcionesSync);
    const hoy = new Date();
    const haceUnMes = new Date();
    haceUnMes.setMonth(hoy.getMonth() - 1);
    const [fechas] = useState({
        fechaDe: haceUnMes,
        fechaHasta: hoy
    });
    const {value, onChange, submitted, onValidate} = useForm({...fechas, modulos: opcionesSync})

    const cerrar = () => {
        onClose();
    }
    const [columnDefs] = useState([
        {field: 'check', headerName: t(''), minWidth: 50,maxWidth: 50, headerCheckboxSelection: true, checkboxSelection: true},
        {field: 'nombre', headerName: t('Proceso'),},
    ]);

    useEffect(() => {
        if (gridRef && gridRef.current && gridRef.current.api)
            gridRef.current.api.forEachNode(node =>
                node.setSelected(false));
    }, []);

    const onSync = useCallback(() => {
        let modulos = []
        gridRef.current.api.forEachNode(node => {
            const { selected, data } = node;
            if (selected) {
                const { key } = data;
                modulos.push(key);
            }
        })
        onSyncClicked({...value, modulos });
    }, [gridRef, value, onSyncClicked])

    return(
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth={'xs'}
        >
            <Form submitted={submitted} onChange={onChange} onValidate={onValidate} value={value}>
                <DialogTitle marginInline={4} marginTop={2} fontWeight={'bold'}>
                    {t('Órdenes de Compra: Sincronización')}
                    <IconButton sx={{position: 'absolute', right: 8, top: 8}} onClick={() => cerrar()}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{marginInline: 4}}>
                    <Box sx={{display: "grid", paddingTop: '8px', width: "100%", gap: "8px"}}>
                        <Field
                            field="fechaDe"
                            componentProps={{ size:'small' }}
                            label={t('Fecha Inicio')}
                            render={fieldCalendar}
                            required={true}
                            value={fechas.fechaDe}
                        />
                        <Field
                            field="fechaHasta"
                            componentProps={{size:'small'}}
                            label={t('Fecha Fin')}
                            render={fieldCalendar}
                            required={true}
                            value={fechas.fechaHasta}
                        />
                        <span style={{fontSize:10, fontWeight:'bold', color:'darkgray'}}>* Solo afecta Órdenes de Compra y Recepciones</span>
                        <AgGridContainer className="ag-theme-material" height={'260px'} style={{marginTop:-10}}>
                            <AgGridReact
                                {...getAgGridDefault(false)}
                                ref={gridRef}
                                rowData={datos}
                                getRowId={(params) => params.data.id}
                                columnDefs={columnDefs}
                                rowSelection={"multiple"}
                                onFirstDataRendered={params => params.api.forEachNode(n => n.setSelected(true))}
                                pagination={false}
                            />
                        </AgGridContainer>
                            <Button  variant="outlined" color={'success'} startIcon={<Sync/>} onClick={onSync}>
                                {t('Sincronizar')}
                            </Button>
                    </Box>
                </DialogContent>
            </Form>

        </Dialog>
    )
}

export default SincronizacionOCs;
